import React, {useState, useRef} from 'react';
import {connect} from "react-redux";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner} from "reactstrap";
import {useTranslation} from "react-i18next";
import {mergeFlowBrodcast} from "../../../../thunks/Audience";
import {apiTableDataRequest} from "../../../../thunks/ApiModel";
import {CancelToken} from "axios";

const CopyStoreSettings = ({
  shops,
  activeShop,
  mergeFlowBrodcast,
  apiTableDataRequest,

  apiPath,
}) => {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedShop, setSelectedShop] = useState(null);
  const [loader, setLoader] = useState(false);

  const closeModal = () => {
    if (loader) return;
    setIsOpen(false);
    setSelectedShop(null);
  };

  const cancelToken = useRef(CancelToken.source());

  const regenerateToken = () => {
    if (cancelToken.current){ cancelToken.current.cancel()}
    cancelToken.current = CancelToken.source()
    return cancelToken.current
  }

  const req = () => {
    setLoader(true);
    mergeFlowBrodcast(selectedShop.id, () => {
      setLoader(false);
      apiTableDataRequest(
        apiPath,
        {
            shop_id: activeShop.id,
        },
        regenerateToken()
      );
      closeModal();
    })
  };

  return <>
    <button className="p-0 border-0 bg-transparent text-muted text-start font-size-md ml-2"
      onClick={() => setIsOpen(true)}>
      {t('CopyStoreSettings.copy_settings')}
    </button>

    <Modal isOpen={isOpen} toggle={closeModal} size="md" scrollable className='CopyStoreSettings_modal'>
      <ModalHeader toggle={closeModal}>
        {t('CopyStoreSettings.modal_title')}
      </ModalHeader>
      <ModalBody className="p-0">
        <ul className="list-group">
          {shops.map(item => (
            <button key={item.id} disabled={item.id === activeShop?.id} type="button" onClick={() => setSelectedShop(item)}
              className={`rounded-0 border-start-0 border-end-0 text-truncate list-group-item list-group-item-action ${selectedShop?.id === item.id ? 'Active' : ''}`}>
              {item.trade_name}
            </button>
          ))}
        </ul>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button color="success" className="py-1 px-4 font-size-lg"
          disabled={!selectedShop} onClick={req}>
          {loader ? <Spinner size="sm"/> : t('copy')}
        </Button>
      </ModalFooter>
    </Modal>
  </>
};

const mapStateToFlowsProps = state => ({
  activeShop: state.Shops.activeShop,
  shops: state.Shops.shops,
});

const mapDispatchToFlowsProps = dispatch => ({
  mergeFlowBrodcast: (shop_id_from, callback) => dispatch(mergeFlowBrodcast(shop_id_from, callback)),
  apiTableDataRequest: (apiPath, queryParams,source) => dispatch(apiTableDataRequest(apiPath, queryParams,false,source)),
});

export default connect(mapStateToFlowsProps, mapDispatchToFlowsProps)(CopyStoreSettings);